import React from 'react';
import Navbar from './componenets/Navbar';

import Rufti from './componenets/Rufti';
import Register from './componenets/Register';
import Login from './componenets/Login';
import './App.css';


function App() {
  return(
<>
    <Navbar/>
    <Rufti/>
    <Register/>
</>
  )
  
  
}

export default App;
